<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :section="'advisersHeader'"
      />
    </template>
    <template v-slot:intro>
      <AdviserEnrolmentIntro
        :heading="intro.heading"
        :lead="intro.lead"
        leadWeight="regular"
        :paragraphs="intro.paragraphs"
      />
      <AdviserEnrolmentAccentuatedContent
        :heading="grow.heading"
        :intro="grow.intro"
        :bullets="grow.bullets"
        :outro="grow.outro"
        web
      />
    </template>
    <template v-slot:channelCta>
      <AdviserChannelSelector
        :heading="channelCta.heading"
        :subtitle="channelCta.subtitle"
        showAllChannels
      />
    </template>
    <template v-slot:linkCards>
      <div class="adviser-link-cards">
        <AdviserBenefitCardGrid :cards="linkCards" />
      </div>
    </template>
  </Layout>
</template>

<script>
  import {
    ADVISER_INTRO,
    ADVISER_GROW,
    ADVISER_CHANNEL_CTA,
    ADVISER_LINK_CARDS,
  } from '@/constants/adviser-enrolment/adviser-content';
  import Layout from '../../common/layouts/Layout.vue';
  import DefaultHeroBar from '../../common/DefaultHeroBar.vue';
  import AdviserEnrolmentIntro from './AdviserEnrolmentIntro.vue';
  import AdviserEnrolmentAccentuatedContent from './AdviserEnrolmentAccentuatedContent.vue';
  import AdviserChannelSelector from './AdviserChannelSelector.vue';
  import AdviserBenefitCardGrid from './AdviserBenefitCardGrid.vue';

  // /adviser is a routing page: no signup form here. Advisers pick their
  // channel and land on /mfc, /ifa or /pf, where the form lives.
  export default {
    name: 'AdviserEnrolment',
    components: {
      Layout,
      DefaultHeroBar,
      AdviserEnrolmentIntro,
      AdviserEnrolmentAccentuatedContent,
      AdviserChannelSelector,
      AdviserBenefitCardGrid,
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    data() {
      return {
        intro: ADVISER_INTRO,
        grow: ADVISER_GROW,
        channelCta: ADVISER_CHANNEL_CTA,
        linkCards: ADVISER_LINK_CARDS,
      };
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'intro',
            background: 'countryPattern',
            fadedRow: true,
          },
          { name: 'channelCta', class: 'section-margin' },
          { name: 'linkCards' },
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-link-cards {
    @include adviser-content-column;
    margin-top: $adviser-section-gap;
    padding-bottom: $adviser-footer-gap;
  }
</style>
